import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { Form, Table, Image, Button, Row } from "react-bootstrap";
import moment from "moment";
import CallingButtonPopup from "../../../reusableComponents/allPopupReusable/CallingButtonPopup";
import SendSmsButton from "../../../reusableComponents/allPopupReusable/SendSmsButton";
import NotificationButton from "../../../reusableComponents/allPopupReusable/NotificationButton";

import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import { FormControl, Select, InputLabel } from "@material-ui/core";
import { IconBoxReusableSeatingComponent } from "../../../reusableComponents/IconBoxReusable/IconBoxReusableComponent";
import LeftSideNavigation from "../../../vendorDashboardComponents/navigationSection/LeftSideNavigation";
import HomeReusableTopBarNavigation from "../../superAdminReusable/superAdminHomeButton/HomeReusableTopBarNavigation";
import SuperAdminCall from "../../superAdminReusable/reusablePopupSuperAdmin/SuperAdminCall";
import SuperAdminNotification from "../../superAdminReusable/reusablePopupSuperAdmin/CustomSuperAdminNotification";
import { RightSideCountTop } from "../superAdminReports/orderingReports/SuperAdminPendingOrderActivityReports";
import SelectFilter from "../../../reusableComponents/selectFilter";
import { AmealioLoader } from "../../../Loader/AmealioLoader";

import propTypes from "prop-types";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { clear_all_errors } from "../../../../store/actions/errorActions";
import {
  admin_get_all_seating_dashboard_summary_r_I,
  admin_get_all_request_count,
} from "../../../../store/actions/SuperAdminActions/adminVendorSummaryReportsAction";
import isEmpty from "../../../../store/validation/is-Empty";

const pendingWhite = require("../../../../assets/images/seatingImages/emailWhite.png");

function VendorSeatingSummaryReports({ ...props }) {
  const dispatch = useDispatch();

  const [filter, showFilter] = useState(false);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const handleSelect = (value) => (e) => {
    setState({
      ...state,
      restaurantReverse: value,
    });
    handleClose();
  };

  const [filterDropDown, setFilterDropDown] = useState("");
  const [state, setState] = useState({
    search: "",
    restaurant_type: "",
    restaurantReverse: "",
  });

  const onChangeRestaurantType = (e) => {
    setFilterDropDown(e.target.value);
  };

  const onSearchChange = (e) => {
    setState({
      ...state,
      search: e.target.value,
    });
  };

  const onFilterSave = (e) => {
    setState({
      ...state,
      restaurant_type: filterDropDown,
    });
    showFilter(!filter);
  };

  /*************************************************
   * @DESC FIRST TIME LOAD COMPONENT API AND STATE
   *************************************************/
  useEffect(() => {
    const token = props.auth.user.accessToken;
    dispatch(admin_get_all_seating_dashboard_summary_r_I(token, false));
    dispatch(admin_get_all_request_count(token, false));
  }, []);

  /*******************************************/
  const [vendorList, setVendorList] = useState([]);
  useEffect(() => {
    setVendorList(props.getAllVendorList);
  }, [props.getAllVendorList]);

  const onDateChangeHandler = () => (data, type) => {
    const token = props.auth.user.accessToken;
    dispatch(
      admin_get_all_seating_dashboard_summary_r_I(
        token,
        true,
        data.startDate,
        data.endDate
      )
    );
  };

  const download_csv = () => {
    // var csv =
    //   "Business ID,Business Name,No. Of Request,Pending Requests,Walk In/Waitlist Requests,Reservation Requests,Restaurant Type,Status\n";
    // vendorList.forEach(function (row) {
    //   csv += row.join(",");
    //   csv += "\n";
    // });
    // var hiddenElement = document.createElement("a");
    // hiddenElement.href = "data:text/csv;charset=utf-8," + encodeURI(csv);
    // hiddenElement.target = "_blank";
    // hiddenElement.download = "people.csv";
    // hiddenElement.click();
  };

  /*************************************************
   * @DESC TABLE BODY COMPONENT FUNCTION
   *************************************************/
  const RenderTableBody = () => {
    const smsDataArr = vendorList && vendorList;
    let filteredData = [];
    if (state.restaurant_type === "") {
      filteredData = smsDataArr;
    } else if (state.restaurant_type !== "") {
      filteredData = smsDataArr.filter(
        (restaurant) =>
          restaurant.primary_restaurant_type &&
          restaurant.primary_restaurant_type[0] &&
          restaurant.primary_restaurant_type[0].title === state.restaurant_type
      );
    }
    if (state.restaurantReverse === "A-Z") {
      filteredData = smsDataArr.sort((a, b) => {
        if (a.restaurant_name < b.restaurant_name) return -1;
        if (a.restaurant_name > b.restaurant_name) return 1;
        return 0;
      });
    } else if (state.restaurantReverse === "Z-A") {
      filteredData = smsDataArr.sort((a, b) => {
        if (a.restaurant_name < b.restaurant_name) return 1;
        if (a.restaurant_name > b.restaurant_name) return -1;
        return 0;
      });
    }
    if (state.search) {
      let search = new RegExp(state.search, "i");
      filteredData = smsDataArr.filter((getall) => {
        if (search.test(getall.message)) {
          return getall;
        } else if (search.test(getall.restaurant_name)) {
          return getall;
        } else if (search.test(getall.primary_restaurant_type[0]?.title)) {
          return getall;
        } else {
          return false;
        }
      });
    }
    // else {
    //   filteredData = smsDataArr;
    // }
    if (!isEmpty(filteredData)) {
      return filteredData.map((data, index) => (
        <React.Fragment key={index}>
          <TableBody smsInfo={data} />
        </React.Fragment>
      ));
    }
  };

  if (props.auth.secondary_loader === true) {
    return (
      <React.Fragment>
        <AmealioLoader />
      </React.Fragment>
    );
  } else {
    return (
      <React.Fragment>
        {/* {console.log(state.restaurant_type)} */}
        <div className="container-fluid">
          <div className="row">
            <div className="left-side-panel">
              <LeftSideNavigation displayLink={1} />
            </div>
            <div className="super-admin-right-side-panel">
              <HomeReusableTopBarNavigation displayText="Reports" />
              <div className="super-admin-inside-right-side-panel">
                <div className="d-flex justify-content-between align-items-center pt-4 pb-3">
                  <div className="f24_700_HelveticaNeue">
                    Vendor Seating Summary Reports
                  </div>
                  <RightSideCountTop
                    content={[
                      {
                        name: "Number of Requests",
                        loader: props.auth.secondary_loader,
                        value: props.getAllCount.totalRequest,
                        backgroundColor: "#FFEDE9",
                        color: "#EE3A23",
                      },
                      {
                        name: "Walk-in/Waitlist requests",
                        loader: props.auth.secondary_loader,
                        value: props.getAllCount.walkInWaitRequest,
                        backgroundColor: "#EFEBFB",
                        color: "#6F32C9",
                      },
                      {
                        name: "Reservation Requests",
                        loader: props.auth.secondary_loader,
                        value: props.getAllCount.reservationRequest,
                        backgroundColor: "#D8F3F4",
                        color: "#138B90",
                      },
                    ]}
                  />
                </div>
                <div className="row">
                  <div className="col-4">
                    <Form.Control
                      type="text"
                      placeholder="Search by business name, restaurant type"
                      name="search"
                      onChange={onSearchChange}
                      value={state.search}
                      className="amSearch"
                    />
                  </div>
                  <div className="col-3"></div>
                  <div className="col-3">
                    <div className="mr-3">
                      {/* <FormControl variant="outlined" fullWidth>
                      <InputLabel id="demo-simple-select-outlined-label">
                        Select date range
                      </InputLabel>
                      <Select
                        labelId="demo-simple-select-outlined-label"
                        id="demo-simple-select-outlined"
                        value={""}
                        onChange={() => {}}
                        label="date_range"
                      >
                        <MenuItem value="">Last 30 days</MenuItem>
                      </Select>
                    </FormControl> */}
                      <SelectFilter
                        onDateChange={() => onDateChangeHandler()}
                      />
                    </div>
                  </div>
                  <div className="col-2">
                    <div className="d-flex align-items-center justify-content-between">
                      <SortByMenu
                        handleClick={handleClick}
                        anchorEl={anchorEl}
                        handleClose={handleClose}
                        selectClick={(data) => handleSelect(data)}
                      />
                      <div
                        className="f10-400"
                        align="center"
                        onClick={() => showFilter(!filter)}
                      >
                        <img
                          src={require("../../../../assets/images/iconButton/filtericon.png")}
                          width="35px"
                        />
                        <br />
                        Filter
                      </div>
                      <div
                        className="f10-400"
                        align="center"
                        onClick={() => download_csv()}
                      >
                        <img
                          src={require("../../../../assets/images/iconButton/downloadicon.png")}
                          width="35px"
                        />
                        <br />
                        Download
                      </div>
                    </div>
                  </div>
                </div>
                {filter && (
                  <div className="mt-3 mb-3">
                    <Row>
                      <div className="col-3">
                        <div className="mr-3">
                          <FormControl variant="outlined" fullWidth>
                            <InputLabel id="demo-simple-select-outlined-label">
                              Restaurant Type
                            </InputLabel>
                            <Select
                              labelId="demo-simple-select-outlined-label"
                              id="demo-simple-select-outlined"
                              name="restaurantType"
                              value={state.filterDropDown}
                              onChange={(e) => onChangeRestaurantType(e)}
                              label="date_range"
                            >
                              {props.restaurant_type &&
                                props.restaurant_type.map((item, index) => (
                                  <MenuItem key={index} value={item.title}>
                                    {item.title}
                                  </MenuItem>
                                ))}
                            </Select>
                          </FormControl>
                        </div>
                      </div>
                    </Row>
                    <div class="d-flex align-items-center mt-2">
                      <button
                        type="button"
                        className="btn-md mr-4 px-5 btn btn-outline-secondary"
                        onClick={() => showFilter(!filter)}
                      >
                        Cancel
                      </button>
                      <button
                        type="button"
                        className="btn-md px-5 btn btn-danger"
                        onClick={onFilterSave}
                      >
                        Search
                      </button>
                    </div>
                  </div>
                )}
                <div className="col-12 p-0 user-table-reusable-superadmin super-admin-all-vendor-main">
                  {/* <div className="col-12 p-0 user-table-reusable-superadmin table-responsive"> */}
                  <Table className="">
                    <thead>
                      <tr className="super_admin_all_users_table_head">
                        <th style={{ width: "15%" }} className="f12-700">
                          Business <br />
                          ID
                        </th>
                        <th style={{ width: "15%" }} className="f12-700">
                          Business Name
                        </th>
                        <th style={{ width: "10%" }} className="f12-700">
                          No. of <br />
                          Request
                        </th>
                        <th style={{ width: "10%" }} className="f12-700">
                          Pending <br />
                          Requests
                        </th>
                        <th style={{ width: "10%" }} className="f12-700">
                          Walk In/Waitlist <br />
                          Requests
                        </th>
                        <th style={{ width: "10%" }} className="f12-700">
                          Reservation <br />
                          Requests
                        </th>
                        <th style={{ width: "10%" }} className="f12-700">
                          Restaurant type
                        </th>
                        <th style={{ width: "20%" }} className="f12-700">
                          Status
                        </th>
                      </tr>
                    </thead>
                    {RenderTableBody()}
                  </Table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

VendorSeatingSummaryReports.propTypes = {
  auth: propTypes.object.isRequired,
  errors: propTypes.object.isRequired,
  admin_get_all_seating_dashboard_summary_r_I: propTypes.func.isRequired,
  admin_get_all_request_count: propTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  restaurant_type: state.category.restaurant_type,
  getAllVendorList:
    state.superAdminVendorSummaryReports.get_all_seating_dashboard_summary,
  getAllCount:
    state.superAdminVendorSummaryReports.get_all_seating_count_reports,
  auth: state.auth,
  errors: state.errors.errors,
});

export default connect(mapStateToProps, {
  clear_all_errors,
  admin_get_all_seating_dashboard_summary_r_I,
  admin_get_all_request_count,
})(withRouter(VendorSeatingSummaryReports));

const SortByMenu = (props) => {
  return (
    <div>
      <div
        className="f10-400"
        align="center"
        aria-controls="simple-menu"
        aria-haspopup="true"
        onClick={props.handleClick}
      >
        <img
          src={require("../../../../assets/images/iconButton/sorticon.png")}
          width="35px"
        />
        <br />
        Sort
      </div>
      <Menu
        id="simple-menu"
        anchorEl={props.anchorEl}
        keepMounted
        open={Boolean(props.anchorEl)}
        onClose={props.handleClose}
      >
        <MenuItem onClick={props.selectClick} disabled>
          Restaurant Name
        </MenuItem>
        <MenuItem onClick={props.selectClick("A-Z")}>A-Z</MenuItem>
        <MenuItem onClick={props.selectClick("Z-A")}>Z-A</MenuItem>
      </Menu>
    </div>
  );
};

const TableBody = (props) => {
  const [TrDetail, setTrDetail] = useState(false);
  const showTr = () => setTrDetail(!TrDetail);
  const data = {
    country_code:
      props.smsInfo?.point_of_contact[0]?.phone_numbers[0]?.country_code,
    mobile_number:
      props.smsInfo?.point_of_contact[0]?.phone_numbers[0]?.mobile_no,
  };
  const formData = {};
  formData.user_details = data;

  return (
    <tbody className="w-100 super-admin-all-vendor-main-table-body">
      <tr className="w-100 p-0">
        <td className="p-0 w-100">
          <table className="w-100">
            <tbody className="sd_body_css">
              <tr className="sd_body_table-row" onClick={showTr}>
                <td style={{ width: "15%" }}>
                  <div className="vendor-main-section-one">
                    <div className="image-box">
                      <div className="Image-box-section">
                        <Image
                          fluid
                          alt="Restaurant Photo"
                          title={props.smsInfo.restaurant_name}
                          src={props.smsInfo.logo_url}
                        />
                        {/* <div className="inside-image-box-discout">
                          <Image
                            fluid
                            alt="Discount Picture"
                            title="Discount Picture"
                            src={require("../../../../assets/images/superadmin/discount.svg")}
                          />
                        </div> */}
                      </div>
                      <div>
                        <h5 className="font_16_m mt-3">#{props.smsInfo._id}</h5>
                      </div>
                    </div>
                    <div className="start-rating-review-box mt-2">
                      <Image
                        fluid
                        alt="wait time"
                        title="wait time"
                        className="star-image-box mr-1"
                        src={require("../../../../assets/images/superadmin/star.svg")}
                      />
                      <h5 className="font_16_m d-flex align-items-center">
                        {props.smsInfo.ratings}
                        <span className="w-100 font_10_r ml-1">
                          ({props.smsInfo.reviews} reviews)
                        </span>
                      </h5>
                    </div>
                  </div>
                </td>
                <td style={{ width: "15%" }}>
                  <h3 className="font_20_m">{props.smsInfo.restaurant_name}</h3>
                </td>
                <td style={{ width: "10%" }}>
                  <div className="f12-500">{props.smsInfo.totalRequest}</div>
                </td>
                <td style={{ width: "10%" }}>
                  <div className="f12-500">{props.smsInfo.pendingRequest}</div>
                </td>
                <td style={{ width: "10%" }}>
                  <div className="f12-500">
                    {props.smsInfo.walkInWaitRequest}
                  </div>
                </td>
                <td style={{ width: "10%" }}>
                  <div className="f12-500">
                    {props.smsInfo.reservationRequest}
                  </div>
                </td>

                <td style={{ width: "10%" }}>
                  <div className="font_18_b">
                    {props.smsInfo.primary_restaurant_type[0]?.title}
                  </div>
                  <div className="font_18_r">
                    {props.smsInfo.primary_cusine[0]?.title}
                  </div>
                  <div className="w-75">
                    <hr />
                    <div className="font_18_r">Organic</div>
                  </div>
                </td>
                <td style={{ width: "20%" }}>
                  <div className="f12-500">{props.smsInfo.status}</div>
                </td>
                {/* <td style={{ width: "10%" }}>
                  <div
                    className="p-2 f10-700"
                    style={{
                      border: "1px solid #EE3A23",
                      borderRadius: "5px",
                    }}
                  >
                    View Dashboard
                  </div>
                </td> */}
              </tr>
              {TrDetail && (
                <>
                  <tr className="sd_accordion_body">
                    <td style={{ width: "18%" }}>
                      <div className="f12-700">Contact</div>
                      <div className="d-flex justify-content-between align-items-center mt-2">
                        {/* <SuperAdminCall /> */}
                        <CallingButtonPopup
                          buttonClass="smallButton"
                          sendData={formData}
                        />
                        {/*<SendSmsButton
                          dataSend={props.dinerInfo}
                          buttonClass="smallButton"
                        />
                        <NotificationButton
                          buttonClass="smallButton"
                          dataSend={props.dinerInfo}
                        /> */}
                        <Button
                          variant="link"
                          className="enIconBtn mr-3"
                          // onClick={handleShowSMS}
                        >
                          <Image
                            src={require("../../../../assets/images/UserManagement/email.svg")}
                            alt="SMS"
                            title="SMS"
                            fluid
                          />
                        </Button>
                        <SuperAdminNotification />
                      </div>
                    </td>
                    <td style={{ width: "15%" }}>
                      <div className="f12-700">Hours of Operation</div>
                      <div className="f12-400 mt-2">
                        {props.smsInfo?.openStatus?.open
                          ? "Closes At"
                          : "Open At"}
                        :{" "}
                        {moment(props.smsInfo?.openStatus?.time, [
                          "HH:mm",
                        ]).format("hh:mm a")}
                        <br />
                        <Image
                          className="mr-2"
                          src={require("../../../../assets/images/Icon/clock.svg")}
                        />
                        {props.smsInfo.seatingWaitingTime}{" "}
                        <span style={{ color: "#F85032" }}>
                          {props.smsInfo.seatingWaitingTime === "00-00"
                            ? "WalkIn"
                            : "Wait"}
                        </span>
                      </div>
                    </td>
                    <td style={{ width: "15%" }}>
                      <div className="f12-700">City/Location</div>
                      <div className="f12-400 mt-2">
                        {props.smsInfo.restaurant_address}
                      </div>
                    </td>
                    <td style={{ width: "15%" }}>
                      <div className="f12-700">Member Since</div>
                      <div className="f12-400 mt-2">
                        {moment(props.smsInfo.createdAt).format("DD/MM/YYYY")}
                      </div>
                    </td>
                  </tr>
                </>
              )}
            </tbody>
          </table>
        </td>
      </tr>
    </tbody>
  );
};
